var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManagebeneficiariesgraybk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#F6F8F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1018_25582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 20C18.93 20 20.5 18.43 20.5 16.5C20.5 14.57 18.93 13 17 13C15.07 13 13.5 14.57 13.5 16.5C13.5 18.43 15.07 20 17 20ZM17 15C17.83 15 18.5 15.67 18.5 16.5C18.5 17.33 17.83 18 17 18C16.17 18 15.5 17.33 15.5 16.5C15.5 15.67 16.17 15 17 15ZM17 21.75C14.66 21.75 10 22.92 10 25.25V26C10 26.55 10.45 27 11 27H23C23.55 27 24 26.55 24 26V25.25C24 22.92 19.34 21.75 17 21.75ZM12.34 25C13.18 24.42 15.21 23.75 17 23.75C18.79 23.75 20.82 24.42 21.66 25H12.34ZM24.04 21.81C25.2 22.65 26 23.77 26 25.25V27H29C29.55 27 30 26.55 30 26V25.25C30 23.23 26.5 22.08 24.04 21.81ZM23 20C24.93 20 26.5 18.43 26.5 16.5C26.5 14.57 24.93 13 23 13C22.46 13 21.96 13.13 21.5 13.35C22.13 14.24 22.5 15.33 22.5 16.5C22.5 17.67 22.13 18.76 21.5 19.65C21.96 19.87 22.46 20 23 20Z",
    fill: "#168617"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1018_25582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagebeneficiariesgraybk);
export default __webpack_public_path__ + "static/media/Managebeneficiariesgraybk.b0002c483433d12a368742f435215368.svg";
export { ForwardRef as ReactComponent };